import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { createNivelSatisfaccion, editNivelSatisfaccion, getNivelesSatisfaccion } from "../../Services/niveles_service";
import { fileUri } from "../../Constantes/constants";
import { UploadFileS3 } from "../File/fileSlice";

const initialState = {
    niveles: [],
    nivel: {
        idNivel: 0,
        nombre: '',
        orden: 0,
        valor: 0,
        estado: 1,
        icono: ''
    },
    nivelSeleccionado: {
        idNivel: 0,
        nombre: '',
        orden: 0,
        valor: 0,
        estado: 1,
        icono: ''
    }
}

export const nivelesSlice = createSlice({
    name: 'rol',
    initialState,
    reducers: {
        setNiveles: (state, action) => {
            state.niveles = action.payload;
        },
        setNivel: (state, action) => {
            state.nivel = action.payload;
        },
        setNivelSeleccionado: (state, action) => {
            state.nivelSeleccionado = action.payload;
        },
        resetNivel: (state) => {
            state.nivel = initialState.nivel;
        }
    }
});

export const fetchNiveles = createAsyncThunk(
    'nivel/fetchNiveles',
    async (_, { dispatch }) => {
        const nivelesRes = await getNivelesSatisfaccion();
        dispatch(setNiveles(nivelesRes));
    }
);

export const addNivel = createAsyncThunk(
    'nivel/create',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const nivelRes = await createNivelSatisfaccion(data);

        if (data.file) {
            const formData = new FormData();
            formData.append('file', data.file,);
            formData.append('tipo', fileUri.portada);
            formData.append('name', `nivel_${nivelRes.data}.jpg`);
            await dispatch(UploadFileS3(formData));
        }

        dispatch(setResponse(nivelRes));
        dispatch(setModal(false));
        dispatch(setNivel(initialState.nivel));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
        dispatch(fetchNiveles());
        dispatch(setLoading(false));
    }
);

export const EditNivel = createAsyncThunk(
    'nivel/update',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const nivelRes = await editNivelSatisfaccion(data);
        if (data.file) {
            const formData = new FormData();
            formData.append('file', data.file,);
            formData.append('tipo', fileUri.portada);
            formData.append('name', `nivel_${nivelRes.data}.jpg`);
            await dispatch(UploadFileS3(formData));
        }

        dispatch(setResponse(nivelRes));
        dispatch(setModal(false));
        dispatch(setNivel(initialState.nivel));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
        dispatch(setLoading(false));
        dispatch(fetchNiveles());
    }
);

export const { setNiveles, setNivel, setNivelSeleccionado } = nivelesSlice.actions;
export default nivelesSlice.reducer;